import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "b-form-recurrence" }
const _hoisted_2 = { class: "h-text-center h-mv-20" }
const _hoisted_3 = { class: "b-base-title h-mt-10 b-form-recurrence__title" }
const _hoisted_4 = {
  key: 0,
  class: "h-flex-center h-mb-10 h-mt-10"
}
const _hoisted_5 = {
  key: 0,
  class: "h-flex-center b-add-edit__form__info h-mt-20"
}
const _hoisted_6 = { class: "b-add-edit__form__info__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeaturesSaveButton = _resolveComponent("FeaturesSaveButton")!
  const _component_FwDatepicker = _resolveComponent("FwDatepicker")!
  const _component_FormMenuItem = _resolveComponent("FormMenuItem")!
  const _component_FwIcon = _resolveComponent("FwIcon")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isSaveButtonShow)
      ? (_openBlock(), _createBlock(_component_FeaturesSaveButton, {
          key: 0,
          onClick: _ctx.setRecurrenceEndHandler
        }, null, 8, ["onClick"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('EVENT.RECURRENCE.END')), 1)
      ]),
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recurrenceEndFeatureList, (item, index) => {
          return (_openBlock(), _createBlock(_component_FormMenuItem, {
            key: index,
            class: "h-mv-10",
            title: _ctx.$t(item.title),
            isActive: index === _ctx.activeIndex,
            leftIcon: "reccurance-icon",
            onClick: ($event: any) => (_ctx.activeIndex = index)
          }, {
            default: _withCtx(() => [
              (item.id === _ctx.validActiveIndex && _ctx.activeIndex === _ctx.validActiveIndex)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_FwDatepicker, {
                      modelValue: _ctx.localEndRecurrenceDate,
                      name: "datepicker",
                      placeholder: _ctx.$t(`ADD.RESERVED.SLOT.FORM.RECURRENCE.CHOOSE_DAY.PLACEHOLDER`),
                      propsRange: false,
                      selectMode: false,
                      pickerStyle: "form",
                      hideIcon: true,
                      propsLang: `${_ctx.$i18n.locale}`,
                      propsType: "date",
                      propsFormat: "DD/MM/YYYY",
                      openOnTop: false,
                      defaultValue: _ctx.startDay,
                      disabledDate: _ctx.startEndRecurrenceDays,
                      propsInputClass: "b-add-reserved-slot-form__datepicker"
                    }, {
                      icon: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                        _createTextVNode("   ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["modelValue", "placeholder", "propsLang", "defaultValue", "disabledDate"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["title", "isActive", "onClick"]))
        }), 128))
      ]),
      (_ctx.isRecurrenceYearly)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createVNode(_component_FwIcon, {
                class: "h-mr-20 h-ml-20",
                icon: "alert-info",
                size: "23",
                color: "#bec7d3"
              })
            ]),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('EVENT.FORM.YEARLY.INFO.ALERT')), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}